module.exports = __webpack_public_path__ + "img/logo_set_old.c1ea58ab.png";